import { ObjectsTable } from '@/components/objects-table';
import { Widget } from '@/components/widget';
import { useGetCapabilities } from '@/features/capabilities/hooks/use-get-capabilities';

interface CapabilitiesListWidgetProps {
  id: string;
  hideable?: boolean;
}

const CAPABILITIES = [
  {
    uuid: '45794cc0-84ae-4594-ba27-309853148b32:freeTextSearch',
    name: 'Free Text Search',
  },
  {
    uuid: 'f901ab37-7f84-4280-a4f5-a4bdb89fa2f1:upsertObject',
    name: 'Upsert Object',
  },
  {
    uuid: 'f901ab37-7f84-4280-a4f5-a4bdb89fa2f1:upsertObject',
    name: 'Send Simple Email',
  },
  {
    uuid: 'f901ab37-7f84-4280-a4f5-a4bdb89fa2f1:upsertObject',
    name: 'Create Table',
  },
  {
    uuid: 'f901ab37-7f84-4280-a4f5-a4bdb89fa2f1:upsertObject',
    name: 'Create Datasheet',
  },
  {
    uuid: '7f98b640-26e4-4ca6-a587-435cff06b601:updateStatus',
    name: 'Update Status',
  },
];

export function CapabilitiesListWidget({
  id,
  hideable = false,
}: CapabilitiesListWidgetProps) {
  const { data: capabilities } = useGetCapabilities();
  function handleDragData(uuid: string, label?: string) {
    return JSON.stringify({
      type: 'object/insert',
      value: [{ uuid, type: 'capability', label }],
    });
  }

  return (
    <Widget title="Capabilities" id={id} hideable={hideable}>
      <ObjectsTable data={capabilities || []} setDragData={handleDragData} />
    </Widget>
  );
}
